// src/masterlogins/utils/api.js

const BASE_URL = 'https://vmsadmin.myworkplace.in/backend'; // ✅ updated for PHP folder

export { BASE_URL };

// ✅ Points to: /backend/master/login.php
export const MASTER_LOGIN = `${BASE_URL}/master_users/login.php`;

// ✅ Points to: /backend/master/show.php (for listing master users)
export const USERS_LIST_ENDPOINT = `${BASE_URL}/master_users/users.php`;
export const MASTER_USER_SAVE_ENDPOINT = `${BASE_URL}/master_users/add.php`; // ✅ updated for PHP folder
export const DELETE_USER_ENDPOINT = `${BASE_URL}/master_users/delete.php`;  // Create this PHP API
export const GET_USER_DATA_UPDATE = `${BASE_URL}/master_users/get_user.php`; // ✅ updated for PHP folder

export const DISTRIBUTOR_LIST_ENDPOINT = `${BASE_URL}/distributors/list.php`; // ✅ updated for PHP folder
export const DISTRIBUTOR_SAVE_ENDPOINT = `${BASE_URL}/distributors/save.php`; // ✅
export const DELETE_DISTRIBUTOR_ENDPOINT = `${BASE_URL}/distributors/delete.php`; // Create this PHP API
export const GET_DISTRIBUTOR_DATA_ENDPOINT = `${BASE_URL}/distributors/get_distributor.php`; // ✅ updated for PHP folder


///////////////////////////////

export const CUSTOMERS_LIST_ENDPOINT = `${BASE_URL}/customers/list.php`; // ✅ updated for PHP folder
export const CUSTOMER_SAVE_ENDPOINT = `${BASE_URL}/customers/save.php`; // ✅ updated for PHP
export const DELETE_CUSTOMER_ENDPOINT = `${BASE_URL}/customers/delete.php`; // Create this PHP API
export const GET_CUSTOMER_DATA_ENDPOINT = `${BASE_URL}/customers/get_customer.php`; // ✅
export const CUSTOMER_PROFILE_ENDPOINT = `${BASE_URL}/customers/profile.php`; // ✅ updated for PHP folder
export const UPDATE_CUSTOMER_AMC = `${BASE_URL}/customers/update_amc.php`; // ✅ updated for PHP folder
export const GET_AMC_HISTORY = `${BASE_URL}/customers/get_amc_list.php`; // ✅ updated for PHP folder
export const TOGGLE_AMC_STATUS  = `${BASE_URL}/customers/toggle_amc_status.php`; // ✅ updated for PHP folder
export const EXTEND_AMC_ENDPOINT = `${BASE_URL}/customers/extend_amc.php`;
///////////////

export const CLIENT_USERS_LIST = `${BASE_URL}/customers_users/list.php`; // ✅ updated for PHP folder
export const CLIENT_USERS_ADD = `${BASE_URL}/customers_users/add.php`; // ✅

export const CLIENT_USERS_UPDATE = `${BASE_URL}/customers_users/update.php`; // ✅ updated for PHP folder
export const CLIENT_USERS_TOGGLE_STATUS = `${BASE_URL}/customers_users/toggle_status.php`;


/////////////////// CUSTOMER LOGIN
export const CUSTOMER_LOGIN_ENDPOINT = `${BASE_URL}/customer_login/login.php`; // ✅ updated for

export const CUSTOMER_COMPANY_INFO_ENDPOINT = `${BASE_URL}/customers_api/company_api/company_info.php`; // ✅ updated for PHP folder